import { reactive, watch } from "vue";
import { IStatusApp } from "../interfaces/status-app.interface";
import { IStatusQuestion } from "../interfaces/status-question.interface";
import { IStatusTimeSlot } from "../interfaces/status-time-slot.interface";
import { IStatusTimeLine } from "../interfaces/status-time-line.interface";
import { IStatusSection } from "../interfaces/status-section.interface";
import { RequestQueue } from "./useRequestQueue";

export const DAYS_IN_DIARY = 7;
export const TIME_SLOTS_PER_DAY = 48;
export const TOTAL_TIME_SLOTS_IN_DIARY = DAYS_IN_DIARY * TIME_SLOTS_PER_DAY;
export const PUBLIC_VAPID_KEY = "BHF2BUW36Oz7Jzn9sUzX9iLoNrhvSF2IafYEyg--ymZKAtltvmcnflwwuj3UKOrzib82giZ8rWRRcBSLg-Yntbw";

export const appStatus = reactive({
    userName: "",  //"Dragos",
    dayIdx: 0,
    timeSlotIdx: 0,
    sectionIdx: 0,
    questionIdx: 0,
    timeLine: {} as IStatusTimeLine,
    timeSlot: {} as IStatusTimeSlot, 
    question: {} as IStatusQuestion,
    adhoc: {} as IStatusSection, 
    breadCrumb: "",
    nextQBtnAccess: true,//I will reuse this later, when loading section on entering a section
    infoMessage: "",
    validationMessage: "",
    validationHit: false,
    showLoginMessage:false,
    displayDropMenu:false,
    isAsSleep:false,
    sleepStartTime: "",
    sleepUntilTime: "",
    sleepStartIndex: 0,
    sleepUntilIndex: 0,
    sleepBlankSpace: 0,
    asleepToggle: false,
    isVisiblePreviousBtn: false,
    isVisibleNextBtn: true,
    displayWakeupContent:false,
    displayWakeupConfirmContent:false,
    timelinePosition: 0,
    timelineInfo: [],
    timelineStartDay: "",
    timelineUntilDay: "",
    datesForSevenDays: [],
    showRightMenus:false,
    showLeftMenus:false,
    firstIncomplete: 0,
    nextIncomplete: 0,
    extentLocationArray: [],
    extentWhomArray: [],
    extentCommunicationArray: [],
    extentActivitiesArray: [],
    allowExtent:false,
    extentSectionComplete:false,
    extentLocationSelected:false,
    extentWhomSelected:false,
    extentCommunicationSelected:false,
    extentActivitiesSelected:false,
    extentSectionsSelected:0,
    extentHighlight:[],
    isTrainingMode:false,
    displayTrainingQuestion:false,
    isDailyComplete:false,
    displayLoading:false,
    showLoadMoreArrow:false,
    timelineOnDrag:false,
    hideAcceptAndRejectBTN:false,
    displayInAppsNotification:false,
    notificationList:[],
    adhocEngine:"",
    adhocProject:"",
    adhocSession:"",
    showMultipleSessionDevicesError: false,
    showMultipleSessionTabsError: false,
    sectionId: -1,
    // useRequestQueue() will be assigned to this property in App.vue onMounted, and stopped in onUnmounted
    // This allows the request queue to be accessible throughout the app via appStatus.requestQueue
    requestQueue: {} as RequestQueue
  } as IStatusApp);

  //When questionIdx changes the question changes
  watch(
    () => appStatus.questionIdx,
    () => {
      appStatus.question = appStatus.timeSlot.sections[appStatus.sectionIdx].questions[appStatus.questionIdx];
    }
  );
  
  export function useAppStatus() {
    return {
      appStatus
    };
  }